export const disney = {
  name: 'Disney plus',
  id: 'disney',
  url: 'https://www.disneyplus.com/',
  color: 'linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(39,70,149,1) 100%)',
  compatible: false
}
